module.exports = __webpack_public_path__ + "img/content13.4abbde14.png";